import { forwardRef } from 'react';

// Dayjs
import { Dayjs } from 'dayjs';

// MUI
import { LocalizationProvider, DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Services
import { useMediaQueries } from 'services/hooks';
import { getAdapterLocale, getLocaleText } from 'services/utils';

// ---------------------------------------------------------------------------------------------------- \\
// ------------------------------------------ DATE PICKER --------------------------------------------- \\
// ---------------------------------------------------------------------------------------------------- \\

const LocaleDatePicker = forwardRef(function LocaleDatePicker(props: DatePickerProps<Dayjs>, ref: React.Ref<HTMLInputElement>) {

    const { mediaDesktop } = useMediaQueries();

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={getAdapterLocale()}
            localeText={getLocaleText()}
        >
            <DatePicker
                {...props}
                inputRef={ref}
                format="DD/MM/YYYY"
                slotProps={{
                    ...props?.slotProps,
                    actionBar: { actions: mediaDesktop ? ['clear'] : ['clear', 'cancel', 'accept'] },
                    textField: { ...props?.slotProps?.textField, fullWidth: true, style: { backgroundColor: 'white' }},
                }}
            />
        </LocalizationProvider>
    );
});

export default LocaleDatePicker;
